import { NavLink } from 'react-router-dom';
import { useAuth } from '../auth';

export const Nav = () => {
  const { user, logout } = useAuth();
  return (
    <nav className="nav">
      <img src="/napoli-logo.png" alt="Napoli Property" className="nav-logo" />
      <NavLink to="/" end>
        Home
      </NavLink>
      <NavLink to="/leases">Leases</NavLink>
      <NavLink to="/tenants">Tenants</NavLink>
      <NavLink to="/properties">Properties</NavLink>
      <NavLink to="/premise-uses">Premise Uses</NavLink>
      <NavLink to="/reconciliation">Reconciliation</NavLink>
      <NavLink to="/audit">Audit</NavLink>
      {user?.isAdmin && <NavLink to="/users">Users</NavLink>}
      <span className="spacer" />
      <span className="user">{user?.name ?? user?.email}</span>
      <button onClick={() => void logout()}>Sign out</button>
    </nav>
  );
};
